import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import { mapLoyaltyEsimUpsellCatalog } from 'api/mappers/loyalty/mapLoyaltyEsimBenefit'
import requestUtils from 'api/requestUtils'
import qs from 'qs'

type CatalogSuccessResponse =
  paths['/api/lux-loyalty/esim/upsell/catalog']['get']['responses']['200']['content']['application/json']

type CatalogRequestQuery =
  paths['/api/lux-loyalty/esim/upsell/catalog']['get']['parameters']['query']

/**
 * Fetches the eSIM upsell catalog for the authenticated customer.
 *
 * Backed by `svc-lux-loyalty` rather than svc-experiences so tier + current-package filtering and
 * currency handling stay server-side.
 */
export default async function requestLoyaltyEsimUpsellCatalog(
  query: CatalogRequestQuery,
): Promise<App.LoyaltyEsimUpsellCatalog> {
  const queryString = qs.stringify(query)
  const response = await requestUtils.get<CatalogSuccessResponse>(
    `/api/lux-loyalty/esim/upsell/catalog?${queryString}`,
    { credentials: 'include' },
  )
  return mapLoyaltyEsimUpsellCatalog(response.result)
}
